// Store Locator Admin Script with Leaflet & OpenStreetMap
let map;
let markers = [];
let storeList = [];
let markerLayer;
let currentEditId = null;
let geocoder;

// Default map center (Massachusetts center)
const defaultCenter = { lat: 42.4072, lng: -71.3824 };

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', function() {
  // Wait a short time to ensure Firebase is fully loaded
  setTimeout(() => {
    initAdminMap();
  }, 500);
});

// Main initialization function
function initAdminMap() {
  console.log("Initializing admin map with Massachusetts center");
  
  // Get map element
  const mapElement = document.getElementById('admin-map');
  if (!mapElement) {
    console.error('Admin map element not found');
    return;
  }
  
  try {
    // Create Leaflet map
    map = L.map('admin-map').setView([defaultCenter.lat, defaultCenter.lng], 8);
    
    // Add OpenStreetMap tile layer
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    }).addTo(map);
    
    // Create a layer group for markers
    markerLayer = L.layerGroup().addTo(map);
    
    // Initialize geocoder
    geocoder = L.Control.Geocoder.nominatim();
    
    // Add map click event to set location
    map.on('click', function(event) {
      setLocationFromMap(event.latlng);
    });
    
    // Add Massachusetts marker
    const maMarker = L.marker([defaultCenter.lat, defaultCenter.lng], {
      title: "Massachusetts",
      icon: L.divIcon({
        className: 'default-marker',
        html: '<div style="background-color: #3388ff; width: 12px; height: 12px; border-radius: 50%; border: 2px solid white;"></div>',
        iconSize: [16, 16],
        iconAnchor: [8, 8]
      })
    }).addTo(map);
    maMarker.bindPopup("<b>Massachusetts</b>");
  } catch (error) {
    console.error('Error initializing map:', error);
    mapElement.innerHTML = '<div style="text-align: center; padding: 20px;">Error loading map. Please try again later.</div>';
    return;
  }
  
  // Set up other event listeners
  setupEventListeners();
  
  // Initialize Firebase explicitly if not already done
  if (typeof firebase !== 'undefined' && !firebase.apps.length) {
    try {
      const firebaseConfig = {
        apiKey: "AIzaSyCc9sZL9h8NdRms9F5u-V7EcNCptg-OJDE",
        authDomain: "washnaturals-36b75.firebaseapp.com",
        databaseURL: "https://washnaturals-36b75-default-rtdb.firebaseio.com",
        projectId: "washnaturals-36b75",
        storageBucket: "washnaturals-36b75.firebasestorage.app",
        messagingSenderId: "776912885702",
        appId: "1:776912885702:web:391e3cdf4d6045a3b344c7",
        measurementId: "G-YXKHE3X1LB"
      };
      firebase.initializeApp(firebaseConfig);
      window.db = firebase.firestore();
      console.log("Firebase initialized manually from store-locator-admin.js");
    } catch (error) {
      console.error("Error initializing Firebase:", error);
      showStatusMessage('Error initializing Firebase. Please try again later.', 'error');
      return;
    }
  } else if (typeof firebase !== 'undefined' && !window.db) {
    window.db = firebase.firestore();
    console.log("Firebase already initialized, connected to Firestore");
  }
  
  // Load store data after initialization
  loadStoreData();
}

// Set up event listeners
function setupEventListeners() {
  // Store form submission
  const storeForm = document.getElementById('store-form');
  if (storeForm) {
    storeForm.addEventListener('submit', function(event) {
      event.preventDefault();
      saveStore();
    });
  }
  
  // Save button
  const saveButton = document.getElementById('store-save');
  if (saveButton) {
    saveButton.addEventListener('click', function() {
      saveStore();
    });
  }
  
  // Cancel edit button
  const cancelEditButton = document.getElementById('cancel-edit-button');
  if (cancelEditButton) {
    cancelEditButton.addEventListener('click', resetForm);
  }
  
  // Filter input
  const filterInput = document.getElementById('store-filter');
  if (filterInput) {
    filterInput.addEventListener('input', filterStores);
  }
  
  // Set up address search
  const addressInput = document.getElementById('store-address');
  if (addressInput) {
    addressInput.addEventListener('blur', function() {
      if (addressInput.value.trim() !== '') {
        geocodeAddress(addressInput.value);
      }
    });
  }
}

// Geocode address to get coordinates
function geocodeAddress(address) {
  if (!address) return;
  
  showStatusMessage('Geocoding address...', 'info');
  
  geocoder.geocode(address, function(results) {
    console.log("Forward geocoding results:", results);
    
    if (results && results.length > 0) {
      const result = results[0];
      let location;
      
      if (result.center) {
        location = result.center;
      } else if (result.geometry && result.geometry.coordinates) {
        location = {
          lat: result.geometry.coordinates[1],
          lng: result.geometry.coordinates[0]
        };
      } else if (result.lat && result.lng) {
        location = result;
      } else {
        console.error("Unexpected geocoder result format:", result);
        showStatusMessage('Geocoding failed: Unexpected result format. Please click on the map to set location.', 'error');
        return;
      }
      
      // Update form fields with the geocoded information
      let city = '';
      let state = '';
      let zip = '';
      let country = 'USA';
      
      if (result.properties && result.properties.address) {
        const props = result.properties.address;
        city = props.city || props.town || props.village || '';
        state = props.state || '';
        zip = props.postcode || '';
        country = props.country || 'USA';
      }
      
      // Update form fields if they're empty
      const cityField = document.getElementById('store-city');
      const stateField = document.getElementById('store-state');
      const zipField = document.getElementById('store-zip');
      const countryField = document.getElementById('store-country');
      
      if (cityField && !cityField.value) cityField.value = city;
      if (stateField && !stateField.value) stateField.value = state;
      if (zipField && !zipField.value) zipField.value = zip;
      if (countryField) countryField.value = country || 'USA';
      
      // Update lat/lng fields
      const latField = document.getElementById('store-lat');
      const lngField = document.getElementById('store-lng');
      
      if (latField && lngField) {
        latField.value = location.lat.toFixed(6);
        lngField.value = location.lng.toFixed(6);
        
        // Highlight the coordinate fields to show they've been updated
        latField.style.backgroundColor = '#e8f4f8';
        lngField.style.backgroundColor = '#e8f4f8';
        
        setTimeout(() => {
          latField.style.backgroundColor = '';
          lngField.style.backgroundColor = '';
        }, 1500);
      }
      
      showStatusMessage(`Geocoding successful: ${location.lat.toFixed(6)}, ${location.lng.toFixed(6)}`, 'success');
      
      // Center map on this location
      map.setView([location.lat, location.lng], 14);
      
      // Add a temporary marker
      clearMarkers();
      const marker = L.marker([location.lat, location.lng]).addTo(markerLayer);
      markers.push(marker);
    } else {
      console.error("No geocoding results found for:", address);
      showStatusMessage('Geocoding failed. Please try a more specific address or click on the map.', 'error');
    }
  });
}

// Set location from map click
function setLocationFromMap(latLng) {
  console.log("Map clicked at:", latLng);
  
  // Add a temporary loading marker
  clearMarkers();
  const marker = L.marker(latLng).addTo(markerLayer);
  markers.push(marker);
  
  // Show message
  showStatusMessage('Looking up address for this location...', 'info');
  
  // Get lat/lng values
  const lat = latLng.lat;
  const lng = latLng.lng;
  
  // Set lat/lng fields
  const latField = document.getElementById('store-lat');
  const lngField = document.getElementById('store-lng');
  
  if (latField && lngField) {
    latField.value = lat.toFixed(6);
    lngField.value = lng.toFixed(6);
  }
  
  // Use the more reliable Nominatim API directly to reverse geocode
  const nominatimUrl = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}&addressdetails=1`;
  
  fetch(nominatimUrl)
    .then(response => response.json())
    .then(data => {
      console.log("Reverse geocoding results:", data);
      
      if (data && data.address) {
        // Extract address components
        const address = data.address;
        
        // Build street address
        let street = '';
        if (address.house_number && address.road) {
          street = `${address.house_number} ${address.road}`;
        } else if (address.road) {
          street = address.road;
        } else if (address.pedestrian) {
          street = address.pedestrian;
        } else if (address.footway) {
          street = address.footway;
        }
        
        // Get city
        const city = address.city || address.town || address.village || address.hamlet || '';
        
        // Get state/province
        const state = address.state || '';
        
        // Get postal code
        const zip = address.postcode || '';
        
        // Get country
        const country = address.country || 'USA';
        
        // Update form fields with highlighting to show changes
        updateFormField('store-address', street || data.display_name.split(',')[0]);
        updateFormField('store-city', city);
        updateFormField('store-state', state);
        updateFormField('store-zip', zip);
        updateFormField('store-country', country);
        
        showStatusMessage(`Location set: ${city}, ${state}`, 'success');
      } else {
        console.log("No reverse geocoding results");
        showStatusMessage(`Location set at coordinates: ${lat.toFixed(6)}, ${lng.toFixed(6)}. Address info not available.`, 'info');
      }
    })
    .catch(error => {
      console.error("Error with reverse geocoding:", error);
      showStatusMessage(`Location set, but address lookup failed.`, 'warning');
    });
}

// Helper function to update form field with highlighting
function updateFormField(fieldId, value) {
  const field = document.getElementById(fieldId);
  if (field && value) {
    const originalValue = field.value;
    field.value = value;
    
    // Only highlight if the value changed
    if (originalValue !== value) {
      field.style.backgroundColor = '#e8f4f8';
      setTimeout(() => {
        field.style.backgroundColor = '';
      }, 1500);
    }
  }
}

// Load store data from Firebase
function loadStoreData() {
  console.log("Attempting to load store data...");
  
  // Display loading message
  const storeListElement = document.getElementById('admin-store-list');
  if (storeListElement) {
    storeListElement.innerHTML = '<div class="store-list-loading">Loading store locations...</div>';
  }
  
  // Check if Firebase is defined
  if (typeof firebase === 'undefined') {
    console.error('Firebase is not defined');
    showStatusMessage('Firebase SDK not loaded. Please check your internet connection and try again.', 'error');
    if (storeListElement) {
      storeListElement.innerHTML = '<div class="error-message">Error: Firebase SDK not loaded.</div>';
    }
    return;
  }
  
  // Check if db is defined
  if (!window.db) {
    console.log('Firebase Firestore not initialized, attempting to initialize...');
    try {
      window.db = firebase.firestore();
      console.log('Firestore initialized from loadStoreData');
    } catch (error) {
      console.error('Could not initialize Firestore:', error);
      showStatusMessage('Error initializing Firestore. Please try again later.', 'error');
      if (storeListElement) {
        storeListElement.innerHTML = '<div class="error-message">Error initializing Firestore.</div>';
      }
      return;
    }
  }
  
  try {
    console.log('Fetching store locations from Firestore collection "store-locations"');
    
    // Fetch store locations from Firestore
    window.db.collection('store-locations')
      .orderBy('name', 'asc')
      .get()
      .then((snapshot) => {
        console.log(`Retrieved ${snapshot.size} stores from Firestore`);
        storeList = [];
        
        if (snapshot.empty) {
          if (storeListElement) {
            storeListElement.innerHTML = '<div class="no-stores-message">No store locations added yet.</div>';
          }
          return;
        }
        
        snapshot.forEach((doc) => {
          const store = doc.data();
          storeList.push({
            id: doc.id,
            name: store.name,
            address: store.address,
            city: store.city,
            state: store.state,
            zip: store.zip,
            country: store.country || 'USA',
            phone: store.phone || '',
            website: store.website || '',
            description: store.description || '',
            lat: parseFloat(store.lat),
            lng: parseFloat(store.lng)
          });
        });
        
        // Display stores
        displayStores(storeList);
      })
      .catch((error) => {
        console.error('Error loading store data:', error);
        showStatusMessage('Error loading store data: ' + error.message, 'error');
        if (storeListElement) {
          storeListElement.innerHTML = `<div class="error-message">Error loading store locations: ${error.message}</div>`;
        }
      });
  } catch (error) {
    console.error('Error in loadStoreData:', error);
    showStatusMessage('Error loading store data: ' + error.message, 'error');
    if (storeListElement) {
      storeListElement.innerHTML = `<div class="error-message">Error: ${error.message}</div>`;
    }
  }
}

// Display stores on map and in list
function displayStores(stores) {
  // Clear existing markers
  clearMarkers();
  
  // Clear store list
  const storeListElement = document.getElementById('admin-store-list');
  if (!storeListElement) return;
  
  storeListElement.innerHTML = '';
  
  // If no stores, show message
  if (!stores || stores.length === 0) {
    storeListElement.innerHTML = '<div class="no-stores-message">No store locations added yet.</div>';
    return;
  }
  
  // Sort stores by name
  stores.sort((a, b) => a.name.localeCompare(b.name));
  
  // Create bounds for auto-zooming
  const bounds = L.latLngBounds();
  bounds.extend([defaultCenter.lat, defaultCenter.lng]); // Always include Massachusetts
  
  // Add each store to map and list
  stores.forEach((store, index) => {
    // Create marker on map
    const latLng = L.latLng(store.lat, store.lng);
    
    const marker = L.marker(latLng, {
      title: store.name
    }).addTo(markerLayer);
    
    // Create popup content
    const content = `
      <div class="map-info-window">
        <h3>${store.name}</h3>
        <p>${store.address}<br>${store.city}, ${store.state} ${store.zip}</p>
        <button onclick="window.editStore(${index})">Edit Store</button>
      </div>
    `;
    
    // Bind popup to marker
    marker.bindPopup(content);
    
    // Add click event to marker
    marker.on('click', function() {
      marker.openPopup();
    });
    
    // Store reference
    markers.push(marker);
    
    // Add to admin list
    addStoreToAdminList(store, index);
    
    // Extend bounds to include this store
    bounds.extend(latLng);
  });
  
  // Fit map to all markers if we have stores
  if (stores.length > 0 && map) {
    map.fitBounds(bounds, { padding: [30, 30] });
  }
}

// Add store to admin list
function addStoreToAdminList(store, index) {
  const storeListElement = document.getElementById('admin-store-list');
  if (!storeListElement) return;
  
  // Create a unique identifier display
  const displayId = store.id ? `ID: ${store.id.substring(0, 4)}...` : `Item #${index+1}`;
  
  const storeItem = document.createElement('div');
  storeItem.className = 'admin-store-item';
  storeItem.id = `admin-store-item-${index}`;
  
  storeItem.innerHTML = `
    <div class="admin-store-info">
      <h3>${store.name}</h3>
      <p>${store.city}, ${store.state}</p>
      <span class="store-id-admin">${displayId}</span>
    </div>
    <div class="admin-store-actions">
      <button class="edit-store-button" onclick="editStore(${index})">Edit</button>
      <button class="delete-store-button" onclick="deleteStore(${index})">Delete</button>
    </div>
  `;
  
  storeListElement.appendChild(storeItem);
}

// Clear all markers from the map
function clearMarkers() {
  markerLayer.clearLayers();
  markers = [];
}

// Filter stores based on search input
function filterStores() {
  const filterText = document.getElementById('store-filter').value.toLowerCase().trim();
  
  if (!filterText) {
    // If filter is empty, show all stores
    displayStores(storeList);
    return;
  }
  
  // Filter stores by name, address, city, state, or zip
  const filteredStores = storeList.filter(store => 
    store.name.toLowerCase().includes(filterText) ||
    store.address.toLowerCase().includes(filterText) ||
    store.city.toLowerCase().includes(filterText) ||
    store.state.toLowerCase().includes(filterText) ||
    store.zip.toLowerCase().includes(filterText)
  );
  
  // Update display with filtered stores
  displayStores(filteredStores);
}

// Edit store
function editStore(index) {
  const store = storeList[index];
  
  // Store the current edit ID
  currentEditId = index;
  
  // Fill form fields
  document.getElementById('store-name').value = store.name;
  document.getElementById('store-address').value = store.address;
  document.getElementById('store-city').value = store.city;
  document.getElementById('store-state').value = store.state;
  document.getElementById('store-zip').value = store.zip;
  document.getElementById('store-country').value = store.country || 'USA';
  document.getElementById('store-phone').value = store.phone || '';
  document.getElementById('store-website').value = store.website || '';
  document.getElementById('store-description').value = store.description || '';
  
  // Set hidden id field if it exists
  const idField = document.getElementById('store-id');
  if (idField) {
    idField.value = store.id;
  }
  
  // Set lat/lng fields
  const latField = document.getElementById('store-lat');
  const lngField = document.getElementById('store-lng');
  if (latField && lngField) {
    latField.value = store.lat;
    lngField.value = store.lng;
  }
  
  // Center map on this store
  if (map) {
    map.setView([store.lat, store.lng], 14);
    
    // Add a marker
    clearMarkers();
    const marker = L.marker([store.lat, store.lng], {
      title: store.name
    }).addTo(markerLayer);
    
    markers.push(marker);
  }
  
  // Focus on name field
  document.getElementById('store-name').focus();
  
  // Scroll to form
  document.querySelector('.store-form-container').scrollIntoView({ behavior: 'smooth' });
  
  // Show cancel button
  const cancelButton = document.getElementById('cancel-edit-button');
  if (cancelButton) {
    cancelButton.style.display = 'inline-block';
  }
  
  // Update save button text
  const saveButton = document.getElementById('store-save');
  if (saveButton) {
    saveButton.textContent = 'Update Store Location';
  }
}

// Delete store
function deleteStore(index) {
  const store = storeList[index];
  
  if (confirm(`Are you sure you want to delete "${store.name}"?`)) {
    // Delete from Firestore
    window.db.collection('store-locations').doc(store.id).delete()
      .then(() => {
        // Show success message
        showStatusMessage(`Store "${store.name}" deleted successfully.`, 'success');
        
        // Reload store data
        loadStoreData();
      })
      .catch((error) => {
        console.error('Error deleting store:', error);
        showStatusMessage('Error deleting store: ' + error.message, 'error');
      });
  }
}

// Reset form
function resetForm() {
  document.getElementById('store-form').reset();
  currentEditId = null;
  document.getElementById('store-id').value = '';
  
  // Reset save button text
  const saveButton = document.getElementById('store-save');
  if (saveButton) {
    saveButton.textContent = 'Find Address & Save Store';
  }
  
  // Hide cancel button
  const cancelButton = document.getElementById('cancel-edit-button');
  if (cancelButton) {
    cancelButton.style.display = 'none';
  }
  
  // Clear map markers except for the default MA marker
  clearMarkers();
}

// Save store (collect form data and save to Firebase)
function saveStore() {
  console.log("saveStore function called");
  
  try {
    // Get form values
    const storeId = document.getElementById('store-id') ? document.getElementById('store-id').value : '';
    const name = document.getElementById('store-name').value.trim();
    const address = document.getElementById('store-address').value.trim();
    const city = document.getElementById('store-city').value.trim();
    const state = document.getElementById('store-state').value.trim();
    const zip = document.getElementById('store-zip').value.trim();
    const country = document.getElementById('store-country').value.trim() || 'USA';
    const phone = document.getElementById('store-phone').value.trim();
    const website = document.getElementById('store-website').value.trim();
    const description = document.getElementById('store-description').value.trim();
    
    console.log("Form values collected:", { name, address, city, state, zip });
    
    // Validate required fields
    if (!name || !address || !city || !state || !zip) {
      console.error("Missing required fields");
      showStatusMessage('Please fill out all required fields', 'error');
      return;
    }
    
    // Format address for geocoding
    const fullAddress = `${address}, ${city}, ${state} ${zip}, ${country}`;
    
    showStatusMessage('Geocoding address...', 'info');
    
    // Use the MapQuest geocoding API which is more reliable
    // Since we can't add API keys here, let's use a simpler approach with the OpenStreetMap Nominatim API
    const nominatimUrl = `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(fullAddress)}&limit=1`;
    
    fetch(nominatimUrl)
      .then(response => response.json())
      .then(data => {
        console.log("Nominatim geocoding results:", data);
        
        if (data && data.length > 0) {
          // Extract coordinates
          const lat = parseFloat(data[0].lat);
          const lng = parseFloat(data[0].lon);
          
          console.log("Geocoded coordinates:", { lat, lng });
          
          // Display the location on the map for confirmation
          if (map) {
            map.setView([lat, lng], 14);
            clearMarkers();
            const marker = L.marker([lat, lng]).addTo(markerLayer);
            markers.push(marker);
          }
          
          showStatusMessage(`Location found: ${lat.toFixed(6)}, ${lng.toFixed(6)}`, 'success');
          
          // Update coordinate fields
          const latField = document.getElementById('store-lat');
          const lngField = document.getElementById('store-lng');
          if (latField && lngField) {
            latField.value = lat.toFixed(6);
            lngField.value = lng.toFixed(6);
          }
          
          // Save store with coordinates
          saveStoreWithCoordinates(
            storeId,
            name,
            address,
            city,
            state,
            zip,
            country,
            phone,
            website,
            description,
            lat,
            lng
          );
        } else {
          console.error("No geocoding results found");
          showStatusMessage('Address could not be found. Please verify the address information.', 'error');
        }
      })
      .catch(error => {
        console.error("Error geocoding with Nominatim:", error);
        showStatusMessage('Error looking up address. Please check your internet connection.', 'error');
      });
  } catch (error) {
    console.error("Error in saveStore function:", error);
    showStatusMessage('Error saving store: ' + error.message, 'error');
  }
}

// Save store with coordinates
function saveStoreWithCoordinates(storeId, name, address, city, state, zip, country, phone, website, description, lat, lng) {
  console.log(`Attempting to save store: ${name}`);
  
  // Check if Firebase and Firestore are available
  if (typeof firebase === 'undefined') {
    console.error('Firebase is not defined when trying to save store');
    showStatusMessage('Firebase SDK not loaded. Please check your internet connection and try again.', 'error');
    return;
  }
  
  if (!window.db) {
    console.error('Firestore is not initialized when trying to save store');
    showStatusMessage('Error: Firebase database not initialized. Please try again later.', 'error');
    return;
  }
  
  // Create store object
  const store = {
    name,
    address,
    city,
    state,
    zip,
    country,
    phone,
    website,
    description,
    lat,
    lng,
    updatedAt: firebase.firestore.FieldValue.serverTimestamp()
  };
  
  console.log('Store object created:', store);
  
  try {
    // Check if editing or adding new
    if (currentEditId !== null && storeId) {
      console.log(`Updating existing store with ID: ${storeId}`);
      // Update existing store in Firestore
      window.db.collection('store-locations').doc(storeId).update(store)
        .then(() => {
          console.log(`Store "${name}" updated successfully`);
          showStatusMessage(`Store "${name}" updated successfully.`, 'success');
          resetForm();
          loadStoreData();
        })
        .catch((error) => {
          console.error('Error updating store:', error);
          showStatusMessage('Error updating store: ' + error.message, 'error');
        });
    } else {
      console.log('Adding new store');
      
      // First check if store with same name and address already exists to prevent duplicates
      window.db.collection('store-locations')
        .where('name', '==', name)
        .where('address', '==', address)
        .where('city', '==', city)
        .where('state', '==', state)
        .get()
        .then((querySnapshot) => {
          if (!querySnapshot.empty) {
            // Store already exists
            console.log('Store with same name and address already exists');
            showStatusMessage(`A store with the name "${name}" at this address already exists.`, 'warning');
            
            // Highlight the existing store in the list if possible
            const existingStore = querySnapshot.docs[0].data();
            const existingId = querySnapshot.docs[0].id;
            
            // Find the index of the store in the store list
            const storeIndex = storeList.findIndex(s => s.id === existingId);
            if (storeIndex >= 0) {
              // Highlight the existing store in the list
              const storeItem = document.getElementById(`admin-store-item-${storeIndex}`);
              if (storeItem) {
                storeItem.style.backgroundColor = '#ffffdd';
                setTimeout(() => {
                  storeItem.style.backgroundColor = '';
                }, 3000);
                
                // Scroll to the item
                storeItem.scrollIntoView({ behavior: 'smooth', block: 'center' });
              }
              
              // Center map on the existing store
              if (map && existingStore.lat && existingStore.lng) {
                map.setView([existingStore.lat, existingStore.lng], 14);
                
                // Highlight the marker
                clearMarkers();
                const marker = L.marker([existingStore.lat, existingStore.lng], {
                  title: existingStore.name
                }).addTo(markerLayer);
                marker.openPopup();
                markers.push(marker);
              }
            }
            
            return;
          }
          
          // No duplicate found, proceed with adding the new store
          // Add createdAt timestamp for new stores
          store.createdAt = firebase.firestore.FieldValue.serverTimestamp();
          
          // Add new store to Firestore
          window.db.collection('store-locations').add(store)
            .then((docRef) => {
              console.log(`New store "${name}" added successfully with ID: ${docRef.id}`);
              showStatusMessage(`Store "${name}" added successfully.`, 'success');
              resetForm();
              loadStoreData();
            })
            .catch((error) => {
              console.error('Error adding store:', error);
              showStatusMessage('Error adding store: ' + error.message, 'error');
            });
        })
        .catch((error) => {
          console.error('Error checking for duplicate stores:', error);
          showStatusMessage('Error checking for duplicate stores: ' + error.message, 'error');
        });
    }
  } catch (error) {
    console.error('Error in saveStoreWithCoordinates:', error);
    showStatusMessage('Error saving store: ' + error.message, 'error');
  }
}

// Create a global reference to the edit store function so it can be called from the marker info window
window.editStore = editStore;
window.deleteStore = deleteStore;

// Show status message
function showStatusMessage(message, type) {
  console.log(`Status message: ${message} (${type})`);
  
  // Get the status element
  let statusElement = document.getElementById('status-message');
  
  // If status element doesn't exist, create it
  if (!statusElement) {
    statusElement = document.createElement('div');
    statusElement.id = 'status-message';
    statusElement.className = 'status-message';
    
    // Insert after the admin description
    const adminDescription = document.querySelector('.store-locator-admin-description');
    if (adminDescription) {
      adminDescription.insertAdjacentElement('afterend', statusElement);
    } else {
      // If we can't find the admin description, insert at the beginning of the page
      const container = document.querySelector('.store-locator-admin-container');
      if (container) {
        container.insertAdjacentElement('afterbegin', statusElement);
      }
    }
  }
  
  // Set message and type
  statusElement.textContent = message;
  statusElement.className = `status-message status-${type}`;
  
  // Show the message
  statusElement.style.display = 'block';
  statusElement.style.opacity = '1';
  
  // Scroll to the message
  statusElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
  
  // Auto-hide after 5 seconds
  setTimeout(() => {
    statusElement.style.opacity = '0';
    setTimeout(() => {
      statusElement.style.display = 'none';
    }, 500);
  }, 5000);
} 